import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X, CheckCircle } from 'lucide-react';
interface Sale {
  name: string;
  location: string;
}
const sales: Sale[] = [{
  name: 'James',
  location: 'London, United Kingdom'
}, {
  name: 'Michael',
  location: 'Toronto, Canada'
}, {
  name: 'David',
  location: 'Sydney, Australia'
}, {
  name: 'Chris',
  location: 'New York, USA'
}, {
  name: 'Daniel',
  location: 'Dublin, Ireland'
}, {
  name: 'Ryan',
  location: 'Chicago, USA'
}, {
  name: 'Mark',
  location: 'Manchester, United Kingdom'
}, {
  name: 'Kevin',
  location: 'Melbourne, Australia'
}, {
  name: 'Brian',
  location: 'Vancouver, Canada'
}, {
  name: 'Jason',
  location: 'Los Angeles, USA'
}, {
  name: 'Sean',
  location: 'Auckland, New Zealand'
}, {
  name: 'Tyler',
  location: 'Dallas, USA'
}];
export function SalesNotification() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(3);
  useEffect(() => {
    if (dismissed) return;
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const cycle = () => {
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setVisible(true);
      hideTimeout = setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % sales.length);
        showTimeout = setTimeout(cycle, 6000);
      }, 5000);
    };
    // first appearance after a short delay
    showTimeout = setTimeout(cycle, 4000);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [index, dismissed]);
  if (dismissed) return null;
  const current = sales[index];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-164">
      <AnimatePresence data-id="element-165">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} role="status" aria-live="polite" className="pointer-events-auto relative flex items-center gap-3 bg-navy-900 border border-navy-700 rounded-xl shadow-2xl pl-3 pr-9 py-3 max-w-[320px]" data-id="element-166">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gold-500 rounded-l-xl" data-id="element-167" />

            <div className="flex-shrink-0 w-11 h-11 rounded-full bg-gold-500/15 text-gold-500 flex items-center justify-center" data-id="element-168">
              <ShoppingBag className="w-5 h-5" data-id="element-169" />
            </div>

            <div className="min-w-0" data-id="element-170">
              <p className="text-sm text-white font-medium leading-tight" data-id="element-171">
                <span className="font-bold" data-id="element-172">{current.name}</span> from{' '}
                <span className="text-gray-300" data-id="element-173">{current.location}</span>
              </p>
              <p className="text-xs text-gray-400 leading-tight mt-0.5" data-id="element-174">
                just got Basketball Ready System 365
              </p>
              <p className="flex items-center gap-1 text-[11px] text-green-400 font-medium mt-1" data-id="element-175">
                <CheckCircle className="w-3 h-3" data-id="element-176" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>

            <button onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" data-id="element-177">
              <X className="w-4 h-4" data-id="element-178" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}